<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("stocktakeLogs") }}</div>
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  href="#"
                  @click="onSelectCinema(dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-md-4">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                @click="stock_take_date = null"
                class="btn-clearDate"
                v-if="stock_take_date"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="stock_take_date"
                typeable
              ></Datepicker>
              <label :class="stock_take_date ? 'active' : ''"
                >{{ $t("stocktake") }} {{ $t("date") }}</label
              >
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && stock_take_date == null"
              >Please Select Stock Take Date.</span
            >
          </p>
        </div>

        <div class="col-md-4">
          <button class="btn-blue" @click.prevent.stop="getStockTakeLogs()">
            {{ $t("fetch") }}
          </button>
        </div>

        <div
          v-if="stock_take_logs && stock_take_logs.length > 0"
          class="d-flex justify-content-end align-items-center w-100 mr-4 mb-2"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="stockTakePDF"
            :href="BASE_URL + stockTakePDF"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="stockTakeExcel"
            :href="BASE_URL + stockTakeExcel"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
      <!-- LIST VIEW DESIGNATION -->
      <div class="swc-report">
        <table class="swc-report-table">
          <thead>
            <tr class="bg-lightgrey">
              <th>{{ $tc("rawmaterials", 2) }}</th>
              <th>{{ "RM Code" }}</th>
              <th>{{ $t("uom") }}</th>
              <th>{{ "Purchase Rate (PR)" }}</th>
              <th>{{ "System Calculated Stock (SCS)" }}</th>
              <th>{{ "SCS Value (SCSV)" }}</th>

              <th>{{ "Counted Stock (CS)" }}</th>
              <th>{{ "CS Value (CSV)" }}</th>
              <th>{{ "Variance (CS -SCS)" }}</th>
              <th>{{ "Variance % (Variance/CS)%" }}</th>
              <th>{{ "Variance Value (Variance * PR)" }}</th>
              <th>{{ "Variance Value to Total Variance %" }}</th>
              <!--<th>{{ $t('amount') }} / {{ $tc('price',1) }} {{ $t('of') }} {{ $t('wastage') }}</th>-->
              <!-- <th>{{ $tc('stocktake') }} {{ $tc('date') }}</th> -->
              <th>{{ $t("Reason") }}</th>
              <th>{{ $t("remarks") }}</th>
              <th>{{ $tc("stocktake") }} {{ $tc("by") }}</th>
            </tr>
          </thead>
          <tbody v-if="stock_take_logs.length > 0">
            <tr
              v-for="(stocks, stocksKey) in stock_take_logs"
              :key="stocksKey"
              :class="[
                stock_take_logs.length &&
                stock_take_logs.length - 1 == stocksKey
                  ? 'bg-lightgrey'
                  : '',
              ]"
            >
              <td>{{ stocks.rm_name }}</td>
              <td>{{ stocks.rm_code }}</td>
              <td>{{ stocks.uom_unit }}</td>

              <!--PR-->
              <td>
                {{
                  stocks.singleRate
                    ? parseFloat(stocks.singleRate || 0).toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    : ""
                }}
              </td>

              <!--System Calculated Stock (SCS)-->
              <td class="text-right">
                {{ stocks.system_calculated_stock }}
              </td>

              <!--SCS Value (SCSV)-->
              <td class="text-right">
                {{ currFormat(stocks.system_calculated_stock_value) }}
              </td>

              <!--'Counted Stock (CS)'-->
              <td>{{ stocks.counted_stock }}</td>
              <!--'CS Value (CSV)'-->
              <td>{{ currFormat(stocks.counted_stock_value) }}</td>

              <td>{{ stocks.variance }}</td>
              <!--'Variance % (Variance/CS)%'-->
              <td>{{ currFormat(stocks.variance_percent) }}</td>

              <!--'Variance Value (Variance * PR)'-->
              <td>{{ currFormat(stocks.variance_value) }}</td>

              <!--'Variance Value to Total Variance %'-->
              <td>{{ currFormat(stocks.variance_total_percent) }}</td>

              <!--<td class="text-right">{{ stocks.ps_amount }}</td>-->

              <td class="text-right">
                {{
                  stocks.reason_value && stocks.reason_value.length > 0
                    ? stocks.reason_value
                    : "-"
                }}
              </td>

              <td class="text-right">
                {{
                  stocks.ps_remark && stocks.ps_remark.length > 0
                    ? stocks.ps_remark
                    : "-"
                }}
              </td>
              <!-- <td>{{ stocks.ps_stock_take_date | dateparse}}</td> -->
              <td>{{ stocks.transfer_by }}</td>
            </tr>
            <tr class="w-100" v-if="stock_take_logs.length == 0">
              <td colspan="14">
                <h6 class="mb-0">
                  No Records Found
                  <br />
                </h6>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService";
  import MasterService from "@/services/MasterService";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        submitted: false,
        Cinemas: [],
        CinemasCopy: [],
        selectedCinema: "",
        totalVariance: 0,
        stock_take_logs: [],
        searchCinema: "",
        selectedid: null,
        stock_take_date: null,
        stockTakePDF: null,
        stockTakeExcel: null,
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      if (true) {
        this.getCinemas(obj);
      }
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.selectedCinema = CinemaObj.cine_name;
        this.selectedid = CinemaObj.cine_id;
        this.stock_take_date = new Date();
        this.getStockTakeLogs();
      }
    },
    mounted() {},
    methods: {
      onSearchCinema: function(value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemas: function(cine_id) {
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.onSelectCinema(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectCinema: function(params) {
        this.selectedCinema = params.cine_name;
        this.selectedid = params.cine_id;
        this.searchCinema = "";
        this.$store.dispatch("selectDropdownCinema", params);
        // this.getStockTakeLogs(params.cine_id);
      },
      getStockTakeLogs: function() {
        this.submitted = true;
        this.stock_take_logs = [];
        if (!this.selectedid) {
          return;
        } else if (!this.stock_take_date) {
          return;
        } else {
          let loader = this.$loading.show();
          PosFnbService.GetStockTakeLogs({
            cinema_id: this.selectedid,
            cinema_name: this.selectedCinema,
            stock_take_date: this.stock_take_date,
          })
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (data.Records && data.Records.length > 0) {
                  this.stock_take_logs = data.Records;
                  this.totalVariance = data.Records.map(
                    (x) => x.ps_variance
                  ).reduce((acc, curr) => acc + curr, 0);
                  this.stockTakePDF = data.FinalPDFFile;
                  this.stockTakeExcel = data.FinalExcelFile;
                } else {
                  this.$toasted.show(data.message);
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      },
    },
  };
</script>

<style scoped>
  .swc-report-table th,
  .swc-report-table td {
    border: 1px solid #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/stockTakeLogs.vue